const $ = window.jQuery;

const ContactModule = {
	init() {
		var $contactmodule = $(document).find('#contactmodule');

		if (!$contactmodule.length) return;

		$contactmodule.on('click', '.toggle-cmodule', function () {
			$contactmodule.toggleClass('active');
			const isOpen = $contactmodule.hasClass('active');
			$(this).attr('aria-expanded', isOpen ? 'true' : 'false');
			$(this).blur();
		});

		$contactmodule.find('#scroll-form-toggle').on('click', function () {
			const $formEl = $contactmodule.find('#gform_2');

			$contactmodule.toggleClass('active-form-scrolled');
			$(this).toggleClass('open-form');
			if ($contactmodule.hasClass('active-form-scrolled')) {
				$formEl.slideDown('fast');
				$formEl.addClass('active-form');
				$(this).text('Dölj formulär');
				$('#contact-person-bio').show();
			} else {
				$formEl.slideUp('fast');
				$formEl.removeClass('active-form');
				$(this).text('Visa formulär');
				$('#contact-person-bio').hide();
			}
		});
	},

	initStickyContact(anchor, content) {
		var $contactmodule = $(document).find('#contactmodule');

		if (!$contactmodule.length) return;

		const adminBar = $('#wpadminbar');
		const scrollPlaceholder = $('#scroller-anchor');
		const $formEl = $contactmodule.find('#gform_2');
		const $formToggle = $contactmodule.find('#scroll-form-toggle');
		var moveFunction1 = function () {
			const headerHeight = $('#header').outerHeight();

			let sidebarWidth = $(anchor).width();
			const contactModuleHeight = $contactmodule.find('.inner').outerHeight();

			$contactmodule.find('.inner').innerWidth(sidebarWidth);

			let offset = headerHeight;
			if (adminBar[0]) {
				offset = headerHeight + adminBar.outerHeight() - 5;
			}

			let topOffset = offset - 15;

			const windowTop = jQuery(window).scrollTop();
			const anchorTop = $(anchor).offset().top;
			const anchorBottom = $(anchor).offset().bottom;
			content = jQuery(content);

			let scrollCheck = $(anchor).height() < windowTop + offset;
			if (adminBar[0]) {
				scrollCheck = $(anchor).height() < windowTop + (offset + adminBar.outerHeight());
			}

			if (window.innerWidth >= 700) {
				if (scrollCheck !== true) {
					if (windowTop > anchorTop - topOffset) {
						$contactmodule.find('.inner').innerWidth(sidebarWidth);
						if ($contactmodule.find('#gform_confirmation_message_2')[0]) {
							scrollPlaceholder.height(109);
						} else {
							scrollPlaceholder.height(509);
						}

						content.css({ position: 'fixed', top: `${offset}px`, bottom: 'unset' });

						if (!$formToggle.hasClass('open-form')) {
							$formToggle.text('Visa formulär');
							$formEl.slideUp('fast');
							$formEl.removeClass('active-form');
							$('#contact-person-bio').hide();
							$contactmodule.removeClass('active-form-scrolled');
							$('#scroll-form-toggle').show();
						}
					}
				}

				if (windowTop <= anchorTop - topOffset) {
					$contactmodule.find('.inner').innerWidth(sidebarWidth);
					scrollPlaceholder.height(0);
					content.css({ position: 'static', top: '', bottom: 'unset' });
					$formEl.slideDown('fast');
					$contactmodule.addClass('active-form-scrolled');
					$formEl.addClass('active-form');
					$formToggle.text('Dölj formulär');
					$('#contact-person-bio').show();
					$('#scroll-form-toggle').hide();

					$formToggle.removeClass('open-form');
				}

				if (scrollCheck === true && windowTop > anchorTop - (offset - 1)) {
					$contactmodule.find('.inner').innerWidth(sidebarWidth);
					/* 		scrollPlaceholder.height(0); */
					content.css({ position: 'absolute', top: 'unset', bottom: '0%' });
					/*  $formEl.slideDown('fast');
                    $('#scroll-form-toggle').hide() */
				}
			}
		};

		$(window).on('scroll', moveFunction1);
		$(window).on('resize', moveFunction1);
		moveFunction1();
	},
};

export default ContactModule;
